import {datadogRum} from '@datadog/browser-rum';
import {scrubUrlQueryParams} from 'util/urlUtils';
import appConfig from '../appConfig';

const SENSITIVE_APP_URL_QUERY_PARAMS = ['t'];

const initializeDatadogRum = (): void => {
  if (!appConfig.datadogRumAppId || !appConfig.datadogRumClientId) {
    console.log('skipping Datadog RUM due to missing credentials.');
    return;
  }

  datadogRum.init({
    applicationId: appConfig.datadogRumAppId,
    clientToken: appConfig.datadogRumClientId,
    env: appConfig.appEnvironment,
    version: appConfig.appBuildId,
    service: 'Delivery Management React',
    site: 'datadoghq.com',
    trackInteractions: true,
    sampleRate: 100,
    beforeSend: event => {
      if (event.type === 'view') {
        const url = new URL(event.view.url);
        // eslint-disable-next-line no-param-reassign
        event.view.url = scrubUrlQueryParams(url, SENSITIVE_APP_URL_QUERY_PARAMS).toString();
        // eslint-disable-next-line no-param-reassign
        event.view.referrer = scrubUrlQueryParams(url, SENSITIVE_APP_URL_QUERY_PARAMS).toString();
      }

      if (event.type === 'resource') {
        const url = new URL(event.resource.url);
        // eslint-disable-next-line no-param-reassign
        event.resource.url = scrubUrlQueryParams(url, SENSITIVE_APP_URL_QUERY_PARAMS).toString();
      }

      if (event.type === 'error' && event.error.resource?.url) {
        const url = new URL(event.error.resource.url);
        // eslint-disable-next-line no-param-reassign
        event.error.resource.url = scrubUrlQueryParams(
          url,
          SENSITIVE_APP_URL_QUERY_PARAMS
        ).toString();
      }
    },
  });
};

export default initializeDatadogRum;
